/** @jsxImportSource @emotion/react */

import { FC, useMemo, useState } from "react";
import Button from "../../../../components/Button";
import Column from "../../../../components/Grid/Column";
import Row from "../../../../components/Grid/Row";
import Typography from "../../../../components/Typography";
import useDocumentDetails from "../../../../hooks/useDocumentDetails";
import { ResultStatus } from "../../../../graphql/__GENERATED__/types";
import { theme } from "../../../../theme";
import { keyframes } from "@emotion/react";

const rotate = keyframes`
from {
  rotate: 0deg;
}
to {
  rotate: 180deg;
}
`;

const styles = {
  button: {
    fontFamily: "inherit",
    fontSize: "clamp(1rem, 3vw, 2rem)",
    fontWeight: "bold",
    width: "100%",
    padding: 16,
    borderRadius: 5,
    cursor: "pointer",
    textTransform: "uppercase" as "uppercase",
    height: 72,
    color: "#224611",
    backgroundColor: theme.colors.Green[100],
    boxShadow: theme.boxShadow.default,
  },
  rotateBar: {
    animation: `${rotate} 1s infinite`,
  },
};

const ApproveQuotation: FC = () => {
  const {
    selectedResultId,
    documentData: { selectedSimulationResults },
    redirectToQuotationFormUrl,
    handleApproveResult,
  } = useDocumentDetails();

  const [loading, setLoading] = useState(false);

  const selectedResult = useMemo(() => {
    return selectedSimulationResults?.find(
      (result) => result?._id === selectedResultId
    );
  }, [selectedResultId]);

  const approvedResult = useMemo(() => {
    return selectedSimulationResults?.find(
      (result) => result?.status === ResultStatus.Approved
    );
  }, [selectedSimulationResults]);

  const approveResult = async (resultId: string) => {
    setLoading(true);
    await handleApproveResult(resultId);
    setLoading(false);
  };

  if (approvedResult) {
    return (
      <>
        <Row>
          <Column>
            <Typography
              variant="textLarge"
              component="p"
              align="left"
              margin="sm"
            >
              Obrigado por aprovar a cotação! Preencha o formulário completo
              para darmos sequência na contratação:
            </Typography>
          </Column>
        </Row>
        <Row justify="center">
          <Column xs={12} md={6} xl={3}>
            <Button
              text="Seguir para formulário"
              style="outlinePrimary"
              onClick={redirectToQuotationFormUrl}
            />
          </Column>
        </Row>
      </>
    );
  }

  return (
    <Row justify="center">
      <Column xs={10}>
        <button
          css={styles.button}
          onClick={() => approveResult(selectedResultId!)}
        >
          {loading ? (
            <div css={styles.rotateBar}>/</div>
          ) : (
            `Quero contratar ${selectedResult?.provider}`
          )}
        </button>
      </Column>
    </Row>
  );
};

export default ApproveQuotation;
